// Import Core
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// Import Libraries
import { useMediaQuery } from 'react-responsive';
// Import Components
import { Button } from './Button';

/* Styled Components */
const ButtonStyles = styled(Button)`
	padding-top: 16px;
	justify-content: flex-start;
	display: none;
	@media (max-width: 768px) {
		display: flex;
	}
`;

const ReadMoreReadLess = ({ content, className }) => {
	const [isReadMoreOpen, setIsReadMoreOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(false)

	const toggleBtn = () => {
		setIsReadMoreOpen((prevState) => !prevState);
	};
	const checkIsMobile = useMediaQuery({ query: `(max-width: 768px)` });
	useEffect(() => {
		setIsMobile(checkIsMobile);
	}, [])

	return (
		<>
			<ul className={className}>
				{isMobile ? (isReadMoreOpen ? content : '') : content}
				<ButtonStyles onClick={toggleBtn} className='text-dark-btn'>
					{isReadMoreOpen ? 'Read Less' : 'Read More'}
				</ButtonStyles>
			</ul>
		</>
	);
};

export default ReadMoreReadLess;
